<div class="fallback" [innerHTML]="fallbackAvatar$ | async"></div>
<div *ngIf="url" class="image" [libBackgroundImage]="url"></div>
